module.exports = __webpack_public_path__ + "media/images/design/icon_03-675d60344ab200f2952c43abf1e007a9.svg";